import { render, staticRenderFns } from "./VersionDetails.vue?vue&type=template&id=6e6c7751&scoped=true&"
import script from "./VersionDetails.vue?vue&type=script&lang=js&"
export * from "./VersionDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6c7751",
  null
  
)

export default component.exports